import React from "react";
import { Button, Stack } from "@mui/material";
import { ButtonIcon } from "@/components/atoms";


interface Action {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  isPrimary?: boolean;
  color?: "primary" | "secondary" | "info" | "error";
  hidden?: boolean;
}

interface ActionButtonProps {
  actions: Action[];
}

const ActionButtons: React.FC<ActionButtonProps> = ({ actions }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {actions.map((action) => {
        if (action.hidden) return undefined;

        if (action.isPrimary) {
          return (
            <Button
              key={action.id}
              variant="contained"
              size="small"
              component="div"
              disableElevation
              startIcon={<action.icon />}
              loading={action.loading}
              disabled={action.disabled}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          )
        } else {
          return (
            <ButtonIcon
              key={action.id}
              onClick={action.onClick}
              color={action.color ?? 'primary'}
              size={30.75}
              Icon={action.icon}
              disabled={action.disabled}
              tooltip={action.label}
            />
          )
        }
      })}
    </Stack>
  );
};

export default ActionButtons;
